import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserFacade } from '@app/store/user';
import { AccountFacade } from '@corelabs/angular-account';
import { Subscription, filter, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CleanupService {
    private accountFacade = inject(AccountFacade);
    private userFacade = inject(UserFacade);
    private router = inject(Router);

    private subscriptions$ = new Subscription();

    constructor() {
        this.subscriptions$.add(
            this.accountFacade.loggedOut$
                .pipe(
                    filter((loggedOut) => loggedOut === true),
                    tap(() => {
                        this.clear();
                        this.router.navigate(['/auth/sign-in']);
                    }),
                )
                .subscribe(),
        );
    }

    private clear() {
        this.userFacade.clear();
        this.accountFacade.clear();
    }
}
